import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  UpdatedAgentValue: {},
};

export const AgentsSlice = createSlice({
  name: "AgentsSlice",
  initialState,
  reducers: {
    UpdatedAgent: (state, action) => {
      state.UpdatedAgentValue = action.payload;
    },
  },
});

export const { UpdatedAgent } = AgentsSlice.actions;
export default AgentsSlice.reducer;
